import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.6967 4.94865C6.10322 3.54213 8.01088 2.75195 10 2.75195C11.9891 2.75195 13.8968 3.54213 15.3033 4.94865C16.7098 6.35518 17.5 8.26283 17.5 10.252C17.5 11.2369 17.306 12.2121 16.9291 13.1221C16.5522 14.032 15.9997 14.8588 15.3033 15.5553C14.6069 16.2517 13.7801 16.8041 12.8701 17.1811C11.9602 17.558 10.9849 17.752 10 17.752C9.01509 17.752 8.03982 17.558 7.12987 17.1811C6.21993 16.8041 5.39314 16.2517 4.6967 15.5553C4.00026 14.8588 3.44781 14.032 3.0709 13.1221C2.69399 12.2121 2.5 11.2369 2.5 10.252C2.5 8.26283 3.29018 6.35518 4.6967 4.94865ZM10 6.50195C10.4142 6.50195 10.75 6.83774 10.75 7.25195V10.252C10.75 10.6662 10.4142 11.002 10 11.002C9.58579 11.002 9.25 10.6662 9.25 10.252V7.25195C9.25 6.83774 9.58579 6.50195 10 6.50195ZM9.25 13.252C9.25 12.8377 9.58579 12.502 10 12.502H10.0075C10.4217 12.502 10.7575 12.8377 10.7575 13.252C10.7575 13.6662 10.4217 14.002 10.0075 14.002H10C9.58579 14.002 9.25 13.6662 9.25 13.252Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}